import { router } from "./screens/router";

import { useHydrateAppStore, useHydrateUserAccount } from "./appStore";
import "./i18n";

import type { Stripe } from "@stripe/stripe-js";
import { RouterProvider } from "react-router";
import { useHydrateChatSchedule } from "./hooks/useChatSchedule";
import { useStartTimer } from "./screens/reader/hooks/useTimer";
import { useWindowScroll } from "./hooks/useScrollVisibility";

// Lazy-load @stripe/stripe-js so it's code-split from main bundle
const loadStripeAsync = async (): Promise<Stripe | null> => {
  const { loadStripe } = await import("@stripe/stripe-js");
  return loadStripe(window.gc.global.stripe_key);
};

// On prod: load eagerly (for fraud detection), on local: load when needed
let stripePromiseCache: Promise<Stripe | null> | null = window.gc.global
  .stripeOnAllPages
  ? loadStripeAsync()
  : null;

export const getStripePromise = (): Promise<Stripe | null> => {
  if (!stripePromiseCache) {
    stripePromiseCache = loadStripeAsync();
  }
  return stripePromiseCache;
};

function App() {
  useHydrateUserAccount();
  useHydrateChatSchedule();
  useStartTimer();
  useHydrateAppStore();
  useWindowScroll();

  return <RouterProvider router={router} />;
}

export default App;
